<template>
  <v-container>
    <v-col cols="4" sm="4">
      <v-select update:modelValue="true" clearable :menu-props="{ maxHeight: 'unset' }" chips label="template"
        :items="Object.keys(this.templates)" @click:clear="onClear($event)" :value="template"
        @update:modelValue="templateChanged"></v-select>
    </v-col>
    <v-col cols="12" v-if="template && templates[template]">
      <v-textarea
        @input="currentTemplateChanged = true"
        v-model="currentTemplateText"
        label="Template Text"
        rows="5"
        auto-grow
      />
    </v-col>
    <v-col>
      <v-btn v-if="template && templates[template]" :disabled="!currentTemplateChanged" @click="onSave('text')">save</v-btn>
    </v-col>
  </v-container>
</template>

<style scoped>
.text-area-container {
  max-height: 250px;
  overflow-y: auto;
}

.emoji-container {
  position: relative;
}

.emoji-container .emoji {
  position: absolute;
  right: 0;
}

.emoji-icon {
  position: absolute;
  display: inline-block;
  left: 200px;
}
</style>

<script>
import { mapState, mapActions } from 'pinia'
import { useSettingStore } from '../../stores/setting'
import { useTemplateStore } from '../../stores/template'
// [matrah] toasts
import { toastSuccess, toastWarning, toastApiError } from '../../utils/notify'

export default {
  name: 'TemplateTextView',
  components: {},
  data: () => ({
    templateText: '',
    previousTemplate: null,
    template: null,
    currentTemplateText: null,
    currentTemplateChanged: false,

    
  }),
  computed: {
    ...mapState(useSettingStore, ['templateImage']),
    ...mapState(useTemplateStore, ['templates']),
  },
  methods: {
    ...mapActions(useSettingStore, [ 'saveTemplateText']),
    ...mapActions(useTemplateStore, ['getTemplates']),


    async onSave() {
      // [matrah] nothing selected → hint instead of a TypeError
      if (!this.template || !this.templates[this.template]) {
        toastWarning('Choose a template first.')
        return
      }

      let data = {
        key: `${this.templates[this.template]['name']}_${this.templates[this.template]['language']}`,
        template_name: `${this.templates[this.template]['name']}`,
        value: this.currentTemplateText
      }
      console.log({
       data,
      })
      // [matrah] legacy: this.saveTemplateText(data)
      try {
        await this.saveTemplateText(data)
        toastSuccess('Template text saved.')
      } catch (error) {
        toastApiError(error, 'Could not save the template text')
      }
    },
    onClear() {
      console.log('onClear', {previousTemplate: this.previousTemplate});
      this.currentTemplateChanged = false
      this.currentTemplateText = null
    },

   templateChanged(value) {

     if (value !== null) {
      this.previousTemplate = value;
      console.log('selected:', value);
    }
    this.templates[this.previousTemplate]['changed'] = false

    this.template = value
    this.currentTemplateChanged = false
    this.currentTemplateText = this.template && this.templates[this.template] ? this.templates[this.template].text : null
    }
  },
  async updated() { },
  // async created() {
  //   let res = await axios.get(`/setting/wellcome_message`);

  //   console.log({
  //     res
  //   })

  //   if (res.data) {
  //     console.log({
  //       resData: res.data.data
  //     })
  //     this.message = res.data['data']['value']
  //   } else {
  //     this.message = ""
  //   }
  // },

  async mounted() {
    // [matrah] legacy: this.getTemplates()
    this.getTemplates().catch((error) => toastApiError(error, 'Could not load templates from Meta'))
    // axios.get("", {
    //   headers: {
    //     Authorization: "Bearer ",
    //   },
    // });
    // let res = await axios.post(`/messages/get-image`, {img_url:'https://lookaside.fbsbx.com/whatsapp_business/attachments/?mid=3382061442055836&ext=1688910872&hash=ATsi0JjbwA8tFBqECGqZ1PSzsbo_eUaieEJWzUzbD9tTbQ'});
    // console.log({res})
  },
}
</script>
